<template>
  <div class="container">
    <section class="newsletter-box">
      <img :src="imgBack" class="img-back" alt="Banner Newsletter" loading="lazy">
      <div class="newsletter-box__body">
        <p class="newsletter-box__description" v-text="translateMain.newsletterMessage" />
        <div class="newsletter-box__textbox">
          <form @submit.prevent="addToNewsletter">
            <input
              type="email"
              name="email"
              :placeholder="translateMain.inputEmail"
              required
              v-model="email"
              @keyup.enter="addToNewsletter"
            />
            <button type="submit" aria-label="Newsletter"><i class="icon-arrow-right"></i></button>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>
<script lang="ts">
  import validationErrors from 'views/shared/mixins/validationErrors'
  import { mapState } from 'pinia'
  import { defineComponent } from 'vue'
  import { localeStore } from 'stores/locale'
  import translateMain from 'tradutors/menu'
  import api from '../../api'

  export default defineComponent({
    name: 'NewsletterBox',
    mixins: [validationErrors],
    emits: ['showModalMessages'],
    computed: {
      ...mapState(localeStore, ['locale']),
      translateMain: function () {
        if (this.locale === 'pt-br') {
          return translateMain.portugues
        } else {
          return translateMain.ingles
        }
      }
    },
    data() {
      return {
        email: '',
        imgBack: 'https://api.belladasemana.com.br/assets/img/home-bg-newsletter.webp'
      }
    },
    methods: {
      save() {
      
      },
      addToNewsletter(){
        api.post('v1/newsletter/storeNewsletterApi?email='+this.email).then(({ data }) => {
          this.$emit('showModalMessages', { 
            message: {
                show: true,
                title: '',
                textBoby: data.return,
                textButton: this.locale == 'pt-br' ? 'Fechar' : 'Close'
            }
          })
        })
      }
      
    }
  })
</script>

<style scoped>
  .img-back {
    position: absolute;
  }

  .newsletter-box {
    margin-bottom: 50px;
    background: unset;
  }

  .newsletter-box__textbox input {
    font-size: 17px;
    position: relative;
    width: 100%;
    height: 100%;
    text-align: start;
    padding: 17px 15px;
    color: #fff;
    border: none;
    background: none; 
    outline: none;
  }

  @media screen and (max-width: 769px) {

    .newsletter-box__textbox input {
      position: relative;
      width: 100%;
      height: 100%;
      text-align: start;
      padding: 17px 15px;
      color: #fff;
      border: none;
      background: none;
      outline: none;
      font-family: 'Roboto-Regular';
      font-size: 13px;
      letter-spacing: 0;

    }
    .newsletter-box {
      top: 25px;
      padding: 30px 0px;
      margin: 0;
    }

    .newsletter-box__description {
      color: #FFFFFF;
      font-family: "Exo-2";
      font-size: 24px;
      letter-spacing: 0;
      line-height: 29px;
      text-align: center;
    }

  }
  @media screen and (max-width: 992px) {
    .img-back {
      display: none;
    }
    .newsletter-box {
      background: #000;
    }    
  }  
</style>
